<template>
  <span
    class="tooltip"
    ref="tooltip"
  >
    <v-icon class="tooltip__icon">mdi-information-outline</v-icon>

    <!-- <span class="tooltip__text">{{ text }}</span> -->
  </span>
</template>

<script>
import { ref, onMounted } from 'vue';
import tippy from 'tippy.js';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const tooltip = ref(null);

    onMounted(() => {
      tippy(tooltip.value, {
        content: props.text,
        delay: [300, 0],
        theme: 'tomato',
        allowHTML: true,
      });
    });

    return {
      tooltip,
    };
  },
};
</script>

<style lang="scss">
.tooltip {
  $this: 'tooltip';
  display: inline-block;
  position: relative;

  // &:hover {
  //   .#{$this}__text {
  //     opacity: 1;
  //     transform: translate(-50%, 0);
  //   }
  // }

  &__icon {
    font-size: 14px;
    color: $color-periwinkle;
    height: auto;
    width: auto;
  }

  // &__text {
  //   pointer-events: none;
  //   position: absolute;
  //   bottom: 100%;
  //   left: 50%;
  //   transform: translate(-50%, 5px);
  //   opacity: 0;
  //   transition: opacity $anim-base, transform $anim-base;
  //   display: block;
  //   padding: 4px 10px;
  //   border-radius: 4px;
  //   background-color: $color-limed-spruce;
  //   color: $color-white;
  //   font-size: 12px;
  //   width: max-content;
  // }
}

.tippy-box[data-theme~='tomato'] {
  background-color: $color-limed-spruce;
  color: $color-white;
  font-size: 12px;
}

.tippy-box[data-theme~='tomato'][data-placement^='top'] > .tippy-arrow:before {
  border-top-color: $color-limed-spruce;
}

.tippy-box[data-theme~='tomato'][data-placement^='bottom']
  > .tippy-arrow:before {
  border-bottom-color: $color-limed-spruce;
}

.tippy-box[data-theme~='tomato'][data-placement^='left'] > .tippy-arrow:before {
  border-left-color: $color-limed-spruce;
}

.tippy-box[data-theme~='tomato'][data-placement^='right']
  > .tippy-arrow:before {
  border-right-color: $color-limed-spruce;
}
</style>
